import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ArtifactType, getArtifactTypeLabel} from 'llm/chat-library/ArtifactTypes';
import {GRAY_LIGHT, GRAY_SEMIDARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface DraftIndicatorButtonProps {
  onClick: () => void;
  /** The type of artifact to display. Defaults to DOCUMENT for backwards compatibility. */
  artifactType?: ArtifactType;
}

export function DraftIndicatorButton({
  onClick,
  artifactType = ArtifactType.DOCUMENT,
}: DraftIndicatorButtonProps): JSX.Element {
  return (
    <div
      className={css(styles.draftDocumentButton)}
      {...getTestProps({component: 'DraftIndicatorButton', element: 'root'})}
    >
      <button type="button" className={css(styles.draftDocumentButtonInner)} onClick={onClick}>
        <span>{getArtifactTypeLabel(artifactType)}</span>
        <BenchlingIcon icon="chevron-right" />
      </button>
    </div>
  );
}

const styles = StyleSheet.create({
  draftDocumentButton: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  draftDocumentButtonInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    backgroundColor: 'white',
    border: `1px solid ${GRAY_LIGHT}`,
    borderRadius: '8px',
    cursor: 'pointer',
    minWidth: '150px',
    fontSize: '14px',
    color: GRAY_SEMIDARK,
    ':hover': {
      backgroundColor: '#f8f9fa',
    },
  },
});
